import { createFileRoute } from '@tanstack/react-router';
import { PayoutTemplateForm } from '@/components/tenants/PayoutTemplateForm';

export const Route = createFileRoute('/dashboard/tenant/$tenantCode/payout-templates/$templateId')({
  component: EditPayoutTemplateRoute,
});

function EditPayoutTemplateRoute() {
  const { tenantCode, templateId } = Route.useParams();

  return <PayoutTemplateForm tenantCode={tenantCode} templateId={templateId} />;
}
